<div class="register-number-outer-container" *ngIf="!isDamagedTemplate">
  <div class="device-caption" *ngIf="!isOnboardingFlow">
    <adp-label [context]="preHeaderTextContext" labelKey="RegisterCellularDevice_PreSelectedDevice_DisplayName_Text"></adp-label>
  </div>
  <div class="info-container">
    <div class="headings-container">
      <div class="heading">
        <adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Header"></adp-label>
      </div>
    </div>
    <div modal-body class="input-container">
      <form [formGroup]="damageQuestionnaireForm" name="damageQuestionnaireFormGroup" class="enter-phonenumber-form">
        <div class="row">
          <div>
            <mat-radio-group class="radio-group radio-group-container" sf-aria-label="Global_SelectOption_Aria_Label" formControlName="selectedDamage">
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="NODAMAGE"><adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Answer_NoDamage"></adp-label></mat-radio-button>
              <mat-radio-button style="text-align:left;" class="radio-field radio-button-container" value="DAMAGE"><adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Answer_Damage"></adp-label></mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row subheading" style="text-align:left;max-width:563px;margin-bottom:20px;margin-top:20px;">
          <adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Disclaimer"></adp-label>
        </div>

        <div class="row">
          <div><button class="register-phone-button" mat-flat-button color="accent"
              (click)="handleNextEvent()" [disabled]="!damageQuestionnaireForm.valid"><adp-label
                labelKey="Global_Button_Next"></adp-label></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="register-number-outer-container" *ngIf="isDamagedTemplate">
  <div class="info-container">
    <div class="headings-container" style="padding-bottom:0px !important;">
      <div>
        <mat-icon style="width:64px;height:64px;overflow:visible !important;"><ng-container *ngTemplateOutlet="redAlertIcon"></ng-container></mat-icon>
      </div>
      <div class="heading">
        <adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Ineligible_Header"></adp-label>
      </div>
    </div>
    <div modal-body class="input-container">
      <div>
        <adp-label labelKey="RegisterCellularDevice_Smartwatch_Questionnaire_Ineligible_Description"></adp-label>
      </div>
    </div>
  </div>
</div>

<ng-template #redAlertIcon>

<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="64" height="64" rx="32" fill="#E16D01" fill-opacity="0.05"/>
  <path d="M32.0009 43.75C30.9676 43.75 30.126 42.9083 30.126 41.875C30.126 40.8417 30.9676 40 32.0009 40C33.0342 40 33.8758 40.8417 33.8758 41.875C33.8758 42.9083 33.0342 43.75 32.0009 43.75Z" fill="#E16D01"/>
  <path d="M32.0009 37.5C31.311 37.5 30.751 36.94 30.751 36.25V23.75C30.751 23.06 31.311 22.5 32.0009 22.5C32.6892 22.5 33.2509 23.06 33.2509 23.75V36.25C33.2509 36.9383 32.6892 37.5 32.0009 37.5Z" fill="#E16D01"/>
  <path d="M15.7882 50C15.2099 50 14.6333 49.865 14.1166 49.6117C13.2117 49.1667 12.5317 48.3933 12.2051 47.4367C11.8784 46.48 11.9434 45.4517 12.3901 44.5467L28.176 12.3817C28.5893 11.54 29.281 10.85 30.1209 10.4367C30.7109 10.1467 31.3409 10 31.9942 10C33.6341 10 35.1024 10.9117 35.824 12.3817L51.6117 44.545C51.865 45.0617 52 45.6383 52 46.2167C52 47.2283 51.605 48.18 50.8884 48.8933C50.1751 49.6067 49.2251 50 48.2152 50H15.7882ZM31.9959 12.5C31.7275 12.5 31.4659 12.56 31.2242 12.68C30.8776 12.85 30.5909 13.1367 30.4209 13.4833L14.6333 45.6483C14.32 46.285 14.5833 47.0567 15.2199 47.3683C15.3949 47.455 15.5899 47.5 15.7849 47.5H48.2135C48.5585 47.5 48.8801 47.3667 49.1235 47.125C49.3668 46.8817 49.5001 46.56 49.5018 46.2167C49.5018 46.02 49.4568 45.825 49.3701 45.65L33.5791 13.4833C33.2858 12.8867 32.6658 12.5 31.9959 12.5Z" fill="#E16D01"/>
  </svg>

</ng-template>
